import { account } from "../slices/accountSlice";
import { userMessages } from "../slices/userMessageSlice";
import { accountingReport } from "../slices/accountingReportSlice";
import { modalsOpen } from "../slices/modalAsTabSlice";
import { changedField } from "../slices/changedFieldSlice";
import { counter } from "../slices/submitCounterSlice";
import { direction } from "../slices/directionSlice";
import { lastActiveTab } from "../slices/lastActiveTabDirectionSlice";
import { modal } from "../slices/modalSlice";
import { grid } from "../slices/gridSlice";
import { parentTabReducer } from "../slices/parentTabSlice";
import { mainTabId } from "../slices/tabIdSlice";
import { paginationData } from "../slices/paginationDataSlice";
import { pagination } from "../slices/paginationSlice";
import { wayBillButton } from "../slices/waybillButtonsSlice";
import { setPricesButton } from "../slices/setPricesButtonSlice";
import { tabTitle } from "../slices/tabTitleSlice";
import { newTab } from "../slices/newTabSlice";

// import { userSettings } from "../slices/accountSlice";

const rootReducer = {
  account,
  userMessages,
  accountingReport,
  modalsOpen,
  changedField,
  counter,
  direction,
  lastActiveTab,
  modal,
  grid,
  parentTabReducer,
  mainTabId,
  paginationData,
  pagination,
  wayBillButton,
  setPricesButton,
  tabTitle,
  newTab,
};

export default rootReducer;
